import React from "react";
import styled from "styled-components";
import { breakpoints } from "../../styles/variables";

const WrapperElem = styled.div`
  position: absolute;
  width: 350px;
  height: 350px;
  z-index: 9;
  
  > * {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  @media screen and (max-width: ${breakpoints.desktop - 1}px) {
    display: none;
  }

  &.obenLinks {
    top: 20px;
    left: 20px;
  }

  &.obenRechts {
    top: 20px;
    right: 20px;
  }

  &.untenLinks {
    bottom: 20px;
    left: 20px;
  }

  &.untenRechts {
    bottom: 20px;
    right: 20px;
  }
`;

interface StoererWrapperProps {
  children: React.ReactNode;
  alignment?: string;
}

const StoererWrapper = ({ children, alignment }: StoererWrapperProps) => (
  <WrapperElem className={alignment || "untenLinks"}>
    {children}
  </WrapperElem>
);

export default StoererWrapper;
